import { render, staticRenderFns } from "./BotProt.vue?vue&type=template&id=0c030ff6&scoped=true&"
import script from "./BotProt.vue?vue&type=script&lang=ts&"
export * from "./BotProt.vue?vue&type=script&lang=ts&"
import style0 from "./BotProt.vue?vue&type=style&index=0&id=0c030ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c030ff6",
  null
  
)

export default component.exports